import { query_rischi_byPrestazione_count, query_rischi_byDataControlloCostante } from "../query/valutazioneRischioQueries";
import {useQuery, useMutation} from "@1f/react-sdk";
import sharedDatasInstance from "../sharedDatas";
import { mutation_delete_rischio } from "../mutations/valutazioniRischioMutations";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { query_rischio_byTenant_stats } from "../query/statsQueries";

export const RischiApi = () => {
    const tenantId = sharedDatasInstance.getPropertyByName("tenantId");
    const aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const errorApiHelpers = apiErrorHelper();
    const apiCountRischiByPrestazione = useQuery(
        query_rischi_byPrestazione_count,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiDeleteRischioById = useMutation(
        mutation_delete_rischio,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"} 
    );  
    const apiRischioByTenantStats = useQuery(
        query_rischio_byTenant_stats,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiRischiByDataControlloCostante = useQuery(
        query_rischi_byDataControlloCostante,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );

    const GetRischiByDataControlloCostante = async () => {
        try {
            const rischiResponse = await apiRischiByDataControlloCostante.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                tenantTipoId: sharedDatasInstance.getPropertyByName("userModel").tenantTipoId,
                dtFrom: new Date(1970, 1, 1),
                dtTo: new Date(new Date().setMonth(new Date().getMonth() + 6)),
            });
            if(rischiResponse && rischiResponse.data){
                return rischiResponse.data.data.rischio.map((rischio) => {
                    return {
                        id: rischio.Id,
                        fascicoloId: rischio.prestazione.fascicolo.Id,
                        fascicoloName: rischio.prestazione.fascicolo.Name,
                        prestazioneId: rischio.PrestazioneId,
                        date: rischio.DataControlloCostante,
                    }
                });
            }
        } catch (error) {
            
        }
    }
    const GetCountRischiByPrestazioneId = async (prestazioneId) => {
        try {
            const countRischi = await apiCountRischiByPrestazione.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                prestazioneId: prestazioneId,
            });           
            if (!countRischi.data.errors) {
                return countRischi.data.data.rischio_aggregate.aggregate.count;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || `Impossibile recuperare i rischi della prestazione`);
        }        
    }
    const DeleteRischioById = async (rischioId) => {
        try {
            const deleteResponse = await apiDeleteRischioById.fetch({                
                id: rischioId
            });
            if (!deleteResponse.data.errors) {
                return true;
            } else {
                console.error(deleteResponse.data.errors);
                return false;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore durante l'eliminazione del rischio");
        }
    }
    const GetRischioLivelloStats = async () => {
        try {
            let rischioStatsResponse = await apiRischioByTenantStats.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
            });
            if (rischioStatsResponse && rischioStatsResponse.data) {
                return rischioStatsResponse.data.data.rischio
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le statistiche dei rischi");
        }
    }

    return {
        GetRischiByDataControlloCostante,
        GetCountRischiByPrestazioneId,
        DeleteRischioById,
        GetRischioLivelloStats
    }
}

export default RischiApi;